module.exports = __webpack_public_path__ + "static/media/excelPicklist2.1558737f.png";